import React from "react";
import { Form, Input, Button, Card, Typography } from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { defaultBusinessHours } from "./defaults";
import type { SectionMeta } from "./types";

export const meta: SectionMeta = {
  key: "business_hours",
  label: "Business Hours",
  icon: <ClockCircleOutlined />,
  color: "#6366f1",
  desc: "Store operating hours",
};

export const defaultData = defaultBusinessHours;

export const Preview: React.FC<{ data: any[] }> = ({ data }) => {
  if (data.length === 0) return null;
  return (
    <div className="space-y-1">
      {data.map((item: any, i: number) => (
        <div key={i} className="flex items-center gap-3 text-sm px-2 py-0.5">
          <span className="text-gray-500 min-w-[130px] text-xs">
            {item.title}
          </span>
          <span className="font-medium text-gray-800">{item.value}</span>
        </div>
      ))}
    </div>
  );
};

export const FormFields: React.FC = () => (
  <Form.List name="business_hours">
    {(fields, { add, remove }) => (
      <>
        {fields.map((field) => (
          <Card
            key={field.key}
            className="!mb-3"
            size="small"
            type="inner"
            extra={
              <Button
                type="text"
                danger
                size="small"
                onClick={() => remove(field.name)}
                icon={<DeleteOutlined />}
              />
            }
          >
            <div className="grid grid-cols-2 gap-3">
              <Form.Item
                {...field}
                name={[field.name, "title"]}
                label="Day(s)"
                className="!mb-0"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input placeholder="e.g. Monday - Friday" />
              </Form.Item>
              <Form.Item
                {...field}
                name={[field.name, "value"]}
                label="Hours"
                className="!mb-0"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input placeholder="e.g. 9:00 AM - 8:00 PM" />
              </Form.Item>
            </div>
          </Card>
        ))}
        <Button
          type="dashed"
          block
          onClick={() => add()}
          icon={<PlusOutlined />}
          className="!mb-1"
        >
          Add Hours Entry
        </Button>
      </>
    )}
  </Form.List>
);
